module.exports = {
  INTERACTIONS: require('./interactions'),
  REVIEW: require('./review'),
  SIG: require('./sig'),
  WORKFLOW: require('./workflow')
}
